import { render, staticRenderFns } from "./jflist.vue?vue&type=template&id=6b54293f&"
import script from "./jflist.vue?vue&type=script&lang=js&"
export * from "./jflist.vue?vue&type=script&lang=js&"
import style0 from "./jflist.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports